import { Injectable, isDevMode } from '@angular/core';
import { API, Auth } from 'aws-amplify';
import { CognitoUser } from '@aws-amplify/auth';
import { DevAWSSettings, ProdAWSSettings } from "../../awsconfig";
import { Client, GetClientResponse } from '../shared-models/client.model';
import { SettingsService } from '../settings/settings.service';
import { ApiResponse } from '../shared-models/api-response.model';
import { ClientUserBrandDetailWithBrand } from './brands.model';
import { MyResultsService } from '../my-results/my-results.service';

@Injectable({
  providedIn: 'root'
})
export class BrandService {

  readonly apiName = "SalesMailUser"
  readonly apiVersion = "2016-04-18";
  readonly awsRegion = "us-east-1";
  public setting = isDevMode() ? new DevAWSSettings() : new ProdAWSSettings();
  
  cognitoUser: CognitoUser;

  constructor(private settingsService: SettingsService, private resultsService: MyResultsService) { }

  async clientHasBrandsEnabled(): Promise<boolean> {
    try {
      const client_id = await this.getCurrentUsersClientId();
      const response: GetClientResponse = await this.settingsService.getClientForStandardUser(client_id);
      
      if(response.value && response.value.length == 0) { return false; }

      const client = response.value[0];
      return client.enable_brands;  
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  async getCurrentUserClient(): Promise<Client | null> {
    const client_id = await this.getCurrentUsersClientId();
    const results = (await this.settingsService.getClientForStandardUser(client_id)).value;
    return results[0] || null;
  }

  async getCurrentUsersClientId():Promise<number> {
    let user: CognitoUser = await Auth.currentAuthenticatedUser();    

    const getUserPromise = new Promise<number>((resolve, reject) => {
      if(!user) { reject('No user defined'); }
      user.getUserAttributes((err, result) => {
        if (err) {
            console.error(err);
            reject('No client ID');
        }
        let clientId = result.filter(item => item.getName() == "custom:client_id").map(att => att.getValue())[0].toString();
        resolve(Number(clientId));
      });
    });

    return getUserPromise;    
  }

  async getAllBrandDetailForUser(): Promise<ApiResponse<ClientUserBrandDetailWithBrand>> {
    const apiInit = {
      headers: {},
      queryStringParameters: {},
    };
    const path = `/user_brands`;
    return API.get(this.apiName, path, apiInit);
  }

  public async updateBrandForVideoId(video_id: number, brand_id: number | null):Promise<any> {
    //Convience passthrough to mysresults service since it already had all the necessary supproting functions
    //Included here just for logical grouping / importing
    return this.resultsService.updateBrandForVideoId(video_id, brand_id);
  }
}
